<block-ui>
  <div class="box">
    <div class="box-header p-3">
      <div class="row col-sm-8">
        <div class="col-sm-4 dcn-resolution">
          <table class="table col-sm-4">
            <tbody>
              <tr>
                <td class="font-weight-bold colon">
                  {{'Store #' | translate}}
                </td>
                <td>{{orderdetailsresponse.storeNumber}}</td>

                <td class="font-weight-bold colon">
                  {{'DC Location' | translate}}
                </td>
                <td>{{orderdetailsresponse.dcAddress}}</td>
              </tr>
              <tr>
                <td class="font-weight-bold colon">
                  {{'OC #' | translate}}
                </td>
                <td>{{orderdetailsresponse.purchaseOrder}}</td>

                <td class="font-weight-bold colon">
                  {{'OC Date' | translate}}
                </td>
                <td>{{orderdetailsresponse.poCreatedTime | date : dateTimeFormat :'' :'fr'}}</td>
              </tr>
              <tr>
                <td class="font-weight-bold colon">
                  {{'Status' | translate}}
                </td>
                <td>   @if (orderdetailsresponse.poStatus !== 5) {
                  <label>  {{ orderdetailsresponse.statusName | translate}} </label>
                }
                @if (orderdetailsresponse.poStatus === 5) {
                  <label>  {{ 'Signed' | translate}} </label>
                }

              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-sm-4 dcn-resolution1" >
        <div class="text-right" >
          <button (click)="backToSummary()" mat-raised-button >{{'Back to Summary' | translate}}</button>
        </div>
        &nbsp;&nbsp;



        @if (orderdetailsresponse.status === 4) {
          <div class="text-right">
            <button mat-icon-button  matTooltip="{{'Signed PDF Report' | translate}}" (click)="openReportPDF()">
              <mat-icon>cloud_download</mat-icon>
            </button>
          </div>
        }
      </div>
    </div>
  </div>
  <div class="box-body ml-2 mr-2 mat-elevation-z8">
    <mat-table  [dataSource]="orderdetailsresponse.orderDetailsDtoList" class="order-summary-table" matSort (matSortChange)="sortData($event)">
      <!-- Position Column -->
      <ng-container matColumnDef="itemDescription">
        <mat-header-cell *matHeaderCellDef mat-sort-header> {{'Product Description' | translate}} </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{ element.itemDescription }} </mat-cell>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="quantity">
        <mat-header-cell *matHeaderCellDef mat-sort-header> {{'Order Qty' | translate}} </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{ element.quantity }} </mat-cell>
      </ng-container>

      <!-- Weight Column -->
      <ng-container matColumnDef="itemNumber">
        <mat-header-cell *matHeaderCellDef mat-sort-header> {{'UPC' | translate}} </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{ element.itemNumber}} </mat-cell>
      </ng-container>

      <!-- Symbol Column -->
      <ng-container matColumnDef="din">
        <mat-header-cell *matHeaderCellDef mat-sort-header> {{'DIN' | translate}} </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{ element.din ? element.din:'--' }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="orderunit">
        <mat-header-cell *matHeaderCellDef mat-sort-header> {{'Pack Size' | translate}} </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{ element.packageSize?element.packageSize:'--'}} </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns;sticky: true"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
    </mat-table>

    <!-- <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator> -->

  </div>
  <div class="box-footer text-right px-3 py-2">
    @if (!ocRcButtonEnable) {
      <button mat-raised-button color="primary" [disabled]="ocRcButtonEnable" (click)="approveOC()">{{'Approve' | translate}}</button>
    }

  </div>
</div>
</block-ui>